import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { WhiteSpace } from 'antd-mobile'
import { Checkbox, Form, Input, List, Radio, Selector, Toast } from 'antd-mobile-v5'
import { FormattedMessage, useIntl } from 'react-intl'
import Status from './DetailStatus'
import {
  formatDate,
  IeExamModule,
  IeResitSubjects,
  languagesMapping,
  removeExpires,
} from '../../components/common/utils'
import { getOssSignature } from '../../reducers/oss'
import OwsiAgreement from './Agreement'
import DiverInfo from '../../components/FormTools/DiverInfo'
import Header from '../../components/FormTools/FormHeader'
import UploadOssFile from '../../components/FormTools/UploadOssFile'
import Signature from '../../components/FormTools/Signature'
import SearchStoreInfo from '../../components/FormTools/SearchStoreInfo'
import DatePickerTool from '../../components/FormTools/DatePicker'
import PickerTool from '../../components/FormTools/Picker'
import dayjs from 'dayjs'
import { useIeExamList, useUploadCourseReport, useUploadTrainingRecord } from '../../services/hooks'

const Item = List.Item

const OwsiCdAppDetailPage = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const [agreement, setAgreement] = useState(false)
  const [signature, setSignature] = useState('')
  const [storeVerify, setStoreVerify] = useState(false)
  const [storeType, setStoreType] = useState()
  const ieAttemptValue = Form.useWatch('ieAttempt', form)
  const idcDateListener = Form.useWatch('idcdate', form)

  const { detail, ossSignature } = useSelector((state) => ({
    detail: state.owsi.cdDetail,
    ossSignature: state.oss.ossSignature,
  }))
  const { data: ieExamList, mutate } = useIeExamList({
    onSuccess: (res) => {
      const newRes = res.map((item) => {
        return {
          value: item.id,
          label: item.ieDate + ' ' + item.location,
        }
      })
      mutate(newRes)
    },
  })
  const { run: uploadTrainingRecord } = useUploadTrainingRecord()
  const { run: uploadCourseReport } = useUploadCourseReport()
  useEffect(() => {
    dispatch(getOssSignature('OWSI'))
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      ieAttempt: [detail.ieAttempt],
      ieExamModules: detail.ieExamModules,
      owfiles: detail.owfiles || [],
      aowfiles: detail.aowfiles || [],
      efrfiles: detail.efrfiles || [],
      rescuefiles: detail.rescuefiles || [],
      aidmfiles: detail.aidmfiles || [],
      heathFiles: detail.heathFiles || [],
      otherFiles: detail.otherFiles || [],
      trainingRecord: detail.trainingRecord || [],
      instructorCourseReportFrom: detail.instructorCourseReportFrom || [],
      ieId: detail.ieScheduleDTO ? detail.ieScheduleDTO.id : '',
      idcdate: detail.idcdate ? new Date(detail.idcdate) : null,
      idcendDate: detail.idcdate ? new Date(detail.idcendDate) : null,
      storeNumber: detail.storeInfoDTO ? detail.storeInfoDTO.storeNumber : '',
      languageId: detail.languageId || '',
      regionId: detail.regionDTO ? detail.regionDTO.region : '',
      alternateLocation: detail.alternateLocation || '',
      storeType: storeType || '',
      writtenExamTimeExtensions: detail.writtenExamTimeExtensions ?? false,
    })
    setSignature(detail.handwrittenSignatureUrlCD)
    setStoreType(detail.storeType)
  }, [detail])

  const validateIdcDate = (_, value) => {
    const idcDate = form.getFieldValue('idcdate')
    const idcEndDate = form.getFieldValue('idcendDate')
    if (!idcDate || !idcEndDate) return Promise.resolve()
    const idcDateObj = dayjs(idcDate)
    const idcEndDateObj = dayjs(idcEndDate)
    // 检查开始日期是否小于结束日期
    if (idcEndDateObj.isBefore(idcDateObj)) {
      return Promise.reject(new Error('结束日期不能早于开始日期'))
    }
    const diffInMonths = idcEndDateObj.diff(idcDateObj, 'month')
    if (diffInMonths > 12) {
      return Promise.reject(new Error('IDC开始日期和IDC结束日期不能超过一年'))
    }
    return Promise.resolve()
  }

  if (!Object.keys(detail).length > 0) return null

  const getSubmitData = () => {
    const values = form.getFieldsValue(true)
    const {
      storeNumber,
      owfiles,
      aowfiles,
      efrfiles,
      rescuefiles,
      aidmfiles,
      heathFiles,
      otherFiles,
      trainingRecord,
      instructorCourseReportFrom,
      ieAttempt,
      idcdate,
      idcendDate,
      ...data
    } = values
    let newData = {
      ...data,
      idcdate: formatDate(idcdate, 'YYYY-MM-DD'),
      idcendDate: formatDate(idcendDate, 'YYYY-MM-DD'),
      owfiles: removeExpires(owfiles),
      aowfiles: removeExpires(aowfiles),
      efrfiles: removeExpires(efrfiles),
      rescuefiles: removeExpires(rescuefiles),
      aidmfiles: removeExpires(aidmfiles),
      heathFiles: removeExpires(heathFiles),
      trainingRecord: removeExpires(trainingRecord),
      instructorCourseReportFrom: removeExpires(instructorCourseReportFrom),
      otherFiles: removeExpires(otherFiles),
      ieAttempt: ieAttempt[0],
    }
    if (storeVerify) newData.storeNumber = storeNumber
    newData.storeType = storeType
    return newData
  }

  const formatIEDate = (date) => {
    const newDate = date.replace('年', '-').replace('月', '-').replace('日', '')
    return newDate
  }

  const getIDCMinEndDate = () => {
    const idcStartDate = form.getFieldValue('idcdate')
    return idcStartDate
  }

  const getIDCMaxEndDate = () => {
    const { preIDCEndDate, ieAttempt } = detail
    if (preIDCEndDate && ieAttempt > 1) {
      const nextDate = dayjs(formatIEDate(preIDCEndDate)).add(1, 'year')
      const todayDate = dayjs()
      if (todayDate.isBefore(nextDate)) {
        return new Date()
      } else {
        return new Date(nextDate)
      }
    }
    const { ieDate } = detail.ieScheduleDTO
    const nextDate = dayjs(formatIEDate(ieDate)).add(1, 'year').subtract(1, 'day')
    const todayDate = dayjs()
    if (todayDate.isBefore(nextDate)) {
      return new Date()
    } else {
      return new Date(nextDate)
    }
  }

  const getIDCMinStartDate = () => {
    const { preIDCEndDate, ieAttempt } = detail
    if (preIDCEndDate && ieAttempt > 1) {
      return new Date(preIDCEndDate)
    }
    const { ieDate } = detail.ieScheduleDTO
    const scheduleDate = formatIEDate(ieDate)
    const subDate = dayjs(scheduleDate).subtract(1, 'year').subtract(1, 'day')
    const formatSubDate = formatDate(subDate, 'YYYY-MM-DD')
    return new Date(formatSubDate)
  }

  const getIDCMaxStartDate = () => {
    const { preIDCEndDate, ieAttempt } = detail
    if (preIDCEndDate && ieAttempt > 1) {
      const nextDate = dayjs(formatIEDate(preIDCEndDate)).add(1, 'year')
      const formatNextDate = formatDate(nextDate, 'YYYY-MM-DD')
      return new Date(formatNextDate)
    }
    const { ieDate } = detail.ieScheduleDTO
    const scheduleDate = dayjs(formatIEDate(ieDate))
    const todayDate = dayjs()
    if (todayDate.isBefore(scheduleDate)) {
      return new Date(todayDate)
    } else {
      return new Date(scheduleDate)
    }
  }

  const changeExtensions = (checked) => {
    if (checked) Toast.show({ content: formatMessage({ id: 'owsi-extensions-reminder' }) })
  }

  const filename = (type) => `${ossSignature.dir}${type}/${new Date().getTime()}`
  const editable = !!(detail.status === 'WAIT_CONFIRM' || detail.status === 'ADMIN_NOT_APPROVED')
  const showTrainingFiles = detail.status === 'INSTRUCTOR_APPROVED'
  return (
    <>
      <Header text={<FormattedMessage id="profile-owsi" />} code={detail?.code} />
      <DiverInfo info={detail.userInfoDTO} />
      <Form form={form} validateTrigger="onSubmit">
        <Form.Header>{formatMessage({ id: 'owsi-ie' })}</Form.Header>
        <Form.Item
          name="ieAttempt"
          label={formatMessage({ id: 'owsi-ie-times' })}
          form={form}
          rules={[
            {
              required: true,
              message: '请选择考试次数',
            },
          ]}
        >
          <Selector columns={2} options={IeExamModule} disabled={!editable} />
        </Form.Item>
        {ieAttemptValue && ieAttemptValue.length > 0 && ieAttemptValue[0] !== 1 && (
          <Form.Item
            name="ieExamModules"
            label={formatMessage({ id: 'owsi-ie-resit' })}
            form={form}
            rules={[
              {
                required: true,
                message: '请选择补考科目',
              },
            ]}
          >
            <Selector columns={2} multiple options={IeResitSubjects} disabled={!editable} />
          </Form.Item>
        )}
        <Form.Header>先决条件</Form.Header>
        {detail.ow ? (
          <Item>{`OW${formatMessage({ id: 'afdi-satisfy' })}`}</Item>
        ) : (
          <Form.Item
            name="owfiles"
            label={'OW'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('ow')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ owfiles: file })}
              editable={editable}
              fileList={form.getFieldValue('owfiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        {detail.aow ? (
          <Item>{`AOW${formatMessage({ id: 'afdi-satisfy' })}`}</Item>
        ) : (
          <Form.Item
            name="aowfiles"
            label={'AOW'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('aow')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ aowfiles: file })}
              editable={editable}
              fileList={form.getFieldValue('aowfiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        {detail.efri || detail.efr ? (
          <Item>{`EFR/EFRI ${formatMessage({ id: 'afdi-satisfy' })}`}</Item>
        ) : (
          <Form.Item
            name="efrfiles"
            label={'EFR/EFRI'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('efri')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ efrfiles: file })}
              editable={editable}
              fileList={form.getFieldValue('efrfiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        {detail.rescue ? (
          <Item>{`RESCUE ${formatMessage({ id: 'afdi-satisfy' })}`}</Item>
        ) : (
          <Form.Item
            name="rescuefiles"
            label={'RESCUE'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('efri')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ rescuefiles: file })}
              editable={editable}
              fileList={form.getFieldValue('rescuefiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        {detail.aidm ? (
          <Item>{`AI/DM ${formatMessage({ id: 'afdi-satisfy' })}`}</Item>
        ) : (
          <Form.Item
            name="aidmfiles"
            label={'AI/DM'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('efri')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ aidmfiles: file })}
              editable={editable}
              fileList={form.getFieldValue('aidmfiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        <Form.Item
          name="heathFiles"
          label={formatMessage({ id: 'app-healthy-statement' })}
          form={form}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'form-upload-error' }),
            },
          ]}
        >
          <UploadOssFile
            form={form}
            fileName={filename('statement')}
            ossSignature={ossSignature}
            onSuccess={(file) => form.setFieldsValue({ heathFiles: file })}
            editable={editable}
            fileList={form.getFieldValue('heathFiles')}
          />
        </Form.Item>
        <Form.Item
          name="otherFiles"
          label={formatMessage({ id: 'mermaid-other-files' })}
          form={form}
          rules={[
            {
              required: false,
              message: formatMessage({ id: 'form-upload-error' }),
            },
          ]}
        >
          <UploadOssFile
            form={form}
            fileName={filename('other')}
            ossSignature={ossSignature}
            onSuccess={(file) => form.setFieldsValue({ otherFiles: file })}
            editable={editable}
            fileList={form.getFieldValue('otherFiles')}
            tips={<FormattedMessage id="app-owsi-other-files" />}
          />
        </Form.Item>
        {/* 潜店信息 */}
        <Form.Header>
          <FormattedMessage id="profile-store-title" />
          <span>
            （<FormattedMessage id="owsi-store-info-tips" />）
          </span>
        </Form.Header>
        <Radio.Group defaultValue={1} disabled={!editable} onChange={(value) => setStoreType(value)} value={storeType}>
          <div style={{ margin: '15px 0px', display: 'flex', justifyContent: 'space-around' }}>
            <Radio value={1}>选择潜店</Radio>
            <Radio value={2}>备选地点</Radio>
          </div>
        </Radio.Group>
        {storeType === 1 && (
          <SearchStoreInfo
            form={form}
            setStoreVerify={setStoreVerify}
            storeVerify={storeVerify}
            editable={editable}
            required={true}
            initStoreInfo={detail.storeInfoDTO}
          />
        )}
        {storeType === 2 && (
          <Form.Item
            name="alternateLocation"
            label={formatMessage({ id: 'owsi-alternative-location' })}
            disabled={!editable}
            rules={[
              {
                required: true,
                message: '备选地点不能为空',
              },
            ]}
          >
            <Input disabled={!editable} placeholder="请输入备选地点" />
          </Form.Item>
        )}
        <Form.Header>教学地址及语言</Form.Header>
        <Form.Item name="regionId" label={formatMessage({ id: 'dm-region' })} disabled={true}>
          <Input />
        </Form.Item>
        <PickerTool
          name={'languageId'}
          form={form}
          rules={[
            {
              required: true,
              message: '语言不能为空',
            },
          ]}
          placeholder={formatMessage({ id: 'dm-lang-error' })}
          data={languagesMapping}
          label={formatMessage({ id: 'dm-lang-title' })}
          disabled={!editable}
        />
        {/* 考试信息 */}
        <Form.Header>{formatMessage({ id: 'owsi-ie' })}</Form.Header>
        <PickerTool
          name={'ieId'}
          form={form}
          rules={[
            {
              required: true,
              message: '考试信息不能为空',
            },
          ]}
          placeholder={formatMessage({ id: 'common-select' })}
          data={ieExamList}
          label={'考试日期和地点'}
          disabled={true}
        />
        {/* 训练材料 */}
        <Form.Header>{formatMessage({ id: 'owsi-upload-training-records' })}</Form.Header>
        {showTrainingFiles ? (
          <UploadOssFile
            fileName={filename(detail.code)}
            ossSignature={ossSignature}
            onSuccess={(file) => uploadTrainingRecord({ code: detail.code, files: removeExpires(file) })}
            editable={showTrainingFiles}
            fileList={form.getFieldValue('trainingRecord')}
            tips={<FormattedMessage id="owsi-cd-other-files" />}
          />
        ) : (
          <Form.Item
            name="trainingRecord"
            label={formatMessage({ id: 'owsi-training-records' })}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename(detail.code)}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ trainingRecord: file })}
              editable={editable}
              fileList={form.getFieldValue('trainingRecord')}
              tips={<FormattedMessage id="owsi-cd-other-files" />}
            />
          </Form.Item>
        )}
        {/* 课程报告 */}
        <Form.Header>{formatMessage({ id: 'owsi-ie-upload-course-report' })}</Form.Header>
        {showTrainingFiles ? (
          <UploadOssFile
            fileName={filename(detail.code)}
            ossSignature={ossSignature}
            onSuccess={(file) => uploadCourseReport({ code: detail.code, files: removeExpires(file) })}
            editable={showTrainingFiles}
            fileList={form.getFieldValue('instructorCourseReportFrom')}
            tips={<FormattedMessage id="owsi-ie-course-report-desc" />}
          />
        ) : (
          <Form.Item
            name="instructorCourseReportFrom"
            label={'课程报告'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename(detail.code)}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ instructorCourseReportFrom: file })}
              editable={editable}
              fileList={form.getFieldValue('instructorCourseReportFrom')}
              tips={<FormattedMessage id="owsi-ie-course-report-desc" />}
            />
          </Form.Item>
        )}
        {/* IDC开始日期&结束日期 */}
        <Form.Header>IDC信息</Form.Header>
        <DatePickerTool
          name="idcdate"
          placeholder={formatMessage({ id: 'form-date-hint' })}
          disabled={!editable}
          label={formatMessage({ id: 'owsi-idc-date' })}
          rules={[
            {
              required: true,
              message: 'IDC开始日期不能为空',
            },
            {
              validator: validateIdcDate,
            },
          ]}
          min={getIDCMinStartDate()}
          max={getIDCMaxStartDate()}
        />
        {idcDateListener && (
          <DatePickerTool
            name="idcendDate"
            max={getIDCMaxEndDate()}
            min={getIDCMinEndDate()}
            placeholder={formatMessage({ id: 'form-date-hint' })}
            disabled={!editable}
            label={formatMessage({ id: 'owsi-idc-end-date' })}
            rules={[
              {
                required: true,
                message: 'IDC结束日期不能为空',
              },
              {
                validator: validateIdcDate,
              },
            ]}
          />
        )}
        <WhiteSpace style={{ backgroundColor: '#F4F8FB' }} />
        <Form.Item name="writtenExamTimeExtensions" form={form}>
          <Checkbox disabled={!editable} onChange={changeExtensions}>
            <FormattedMessage id="owsi-extensions" />
          </Checkbox>
        </Form.Item>
      </Form>
      <WhiteSpace />
      <Signature
        title={formatMessage({ id: 'dm-form-signature' })}
        filePath={'signature'}
        modified={editable}
        oss={ossSignature}
        onSuccess={(imgUrl) => setSignature(imgUrl)}
        onClear={() => setSignature('')}
        initSignature={detail.handwrittenSignatureUrlCD}
      />
      {editable && (
        <>
          <WhiteSpace />
          <OwsiAgreement changeChecked={setAgreement} />
        </>
      )}
      <WhiteSpace />
      <Status form={form} cdDetail={detail} agreement={agreement} getSubmitData={getSubmitData} signature={signature} />
      <WhiteSpace size="lg" />
    </>
  )
}

export default OwsiCdAppDetailPage
